angular.module('ApptBookApp').controller('AppointmentAuditLogController', [
    '$scope', 
    '$http', 
    '$rootScope', 
    'restServer', 
    'appointmentBookModalService', 
    'appointmentId', 
    'appointmentServiceScheduleId', 
    'meevo.components.busy.BusyService',
	'meevo.AppSettings',
	'appointmentRequestId',
	'meevo.components.common.DataService',
    (
		$scope,
		$http,
		$rootScope,
		restServer,
		modal,
		appointmentId,
		appointmentServiceScheduleId,
		busyService: Meevo.Components.Busy.IBusyService,
		appSettings: Meevo.Components.Common.IAppSettings,
		appointmentRequestId: string,
		dataService: Meevo.Components.Common.ICommonDataService
	) => {
	    $scope.modal = modal;
	    $scope.service = [];

	    if (appointmentId != undefined) {
		    restServer.getAppointmentAuditHistory(appointmentId, appSettings, response => {
			    $scope.service = response;
		    });
	    }
	    else if (appointmentServiceScheduleId != undefined) {
		    restServer.getAppointmentScheduleAuditHistory(appointmentServiceScheduleId, appSettings, response => {
			    $scope.service = response;
		    });
		}
		else if (appointmentRequestId)
		{
			$scope.header = "LABEL_WAIT_AUDIT_HISTORY";
			dataService.customMethodData(`/api/AppointmentRequest/${appointmentRequestId}/History?locale=${appSettings.APP_COUNTRYID}&timeFormat=${appSettings.APP_TIME_FORMAT}`,
				"get", {}).then(response => {
				$scope.service = response.data;
			});
        }
	    else {
		    busyService.stop();
	    }
    }
]);